import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../helpers";
import Tariff from "./Tariff";
import "./index.scss";

const StickyBlock = ({ sticky, bottom, stickyBlockRef }) => {
  const {
    data: { currentPeriod },
    modes: { mode },
  } = useContext(SimpleContext);

  return (
    <div
      className={getTrueClasses(
        "GP-C-SB",
        !bottom && sticky && "GP-C-SB_sticky",
        !sticky && bottom && "GP-C-SB_bottom",
        mode && `GP-C-SB_${mode}`,
        !currentPeriod && "GP-C-SB_hideInfo"
      )}
      ref={stickyBlockRef}
    >
      <Tariff />
    </div>
  );
};

StickyBlock.propTypes = {
  isSticky: PropTypes.bool,
  stickyBlockRef: PropTypes.object,
};

export default StickyBlock;
